import Tile4 from './Tiles4';

export * from './types';

export default Tile4;
